import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './jobFamilies.intl.json';

export const useJobFamiliesIntl = () => useIntlModule(messages);
